
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import dataModel from '../../../models/DataModel';
import LoadingDots from '../../../components/LoadingDots';
import ReportFilter from '../../../containers/ManagerDashboard/ReportFilter';
import ReportHeader from '../../../containers/ManagerDashboard/ReportHeader';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import AddProjectGroupPopup from '../AddProjectGroupPopup';
import ProjectGroup from '../ProjectGroup';
import projectGroupService from '../../../services/projectGroupService';
import projectTemplatesService from '../../../services/projectTemplatesService';

import './ProjectGroupsSummary.scss';

export class ProjectSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
    //   loadingMore: true,
      isProjectGroupPopupActive: false,
      projectGroups: [],
      searchString: '',
      searchedProjectGroups: [],
    };
    this.filterStats = {
      projectStatusCount: 0,
      projectTypeCount: 0,
      projectContractIdCount: 0,
      projectManagerCount: 0,
      archivedCount: 0,
      projectEventType: null,
      startDate: null,
      endDate: null,
    };
    
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleProjectClick = this.handleProjectClick.bind(this);
    this.handleCloseoutGenerated = this.handleCloseoutGenerated.bind(this);
    // this.handleLoadMoreProjects = this.handleLoadMoreProjects.bind(this)
    this.handleAddProjectGroup = this.handleAddProjectGroup.bind(this);
    this.handleAddGroup = this.handleAddGroup.bind(this);
    this.handleDeleteGroup = this.handleDeleteGroup.bind(this);
    this.handleCloseAddProjectGroupPopup = this.handleCloseAddProjectGroupPopup.bind(this);
  }

  async handleProjectGroupsRetrieval() {
    const { currentCompany } = this.props;
    const { searchString } = this.state;
  
    const response = await projectGroupService.getProjectGroups(currentCompany.id);
    const projectGroups = [];
    response.data.forEach(group => {
      projectGroups.push(group.attributes);
    });
    this.setState({ projectGroups, searchedProjectGroups: [] });
    if(searchString){
      this.handleSearchChange(searchString);
    }
    return projectGroups;
  }

  componentDidMount() {

    const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    projectTemplatesService.getProjectTemplateCloseouts().then(closeout_templates => {
      this.setState({ closeout_templates });
    });
    this.handleProjectGroupsRetrieval();
  }

  handleCloseoutGenerated() {
    this.analyticsLogger.logCloseoutDocument('CloseoutDocumentGeneratedProjectGroupSummary');
  }

  createProjectGroupRows() {
    const { projectGroups, searchedProjectGroups, searchString } = this.state;

    let filteredProjectGroups = searchString ? searchedProjectGroups : projectGroups;
    if(filteredProjectGroups){      
      return filteredProjectGroups.map((projectGroup, index) => {
        const canSelect = !projectGroup.archived_at;
        let projectIds = [];
        if(projectGroup.projects.length > 0){
          projectIds = projectGroup.projects.map(project => project.id);
        }
        return (
          <div
          className={'project-groups-summary-row' + (canSelect ? ' selectable': '')} key={index}
          id={projectGroup.id}
          > 
            <ProjectGroup 
              projectGroup={projectGroup} 
              projectsList={projectIds}
              currentCompany={this.props.currentCompany}
              permissions={this.props.permissions}
              handleCloseoutGenerated={this.handleCloseoutGenerated}
              handleProjectClick={this.handleProjectClick}
              closeout_templates={this.state.closeout_templates}
              handleEditGroup={this.handleAddGroup}
              onDelete={this.handleDeleteGroup}
            />
          </div>
        );
      });
    }
  }

  handleProjectClick(e, project_id, canSelect) {
    if (canSelect) {
      e.preventDefault();
      this.analyticsLogger.logProjectListEvent('ProjectSummaryClickthrough');
      this.props.history.push('/projects/' + project_id);
    }
  }
  
  handleDeleteGroup(){
    this.handleProjectGroupsRetrieval();
  }

  handleAddProjectGroup(){
    this.setState({ isProjectGroupPopupActive: true });
  }

  async handleAddGroup() {
    return new Promise((resolve, reject) => {
      this.handleProjectGroupsRetrieval()
      .then(() => {
        this.handleCloseAddProjectGroupPopup();
        resolve();
      });
    });
  }

  handleCloseAddProjectGroupPopup(){
    this.setState({ isProjectGroupPopupActive: false });
  }

  handleSearchUsers(matchedProjects) {
    // Set the matched projects to the state to display them
    this.setState({ searchedProjectGroups: matchedProjects });
  }

  handleSearchChange(searchString) {
    const { projectGroups } = this.state;
  
    if (searchString && searchString.length > 2) {
      // Filter projects based on the search string
      let matchedProjects = projectGroups.filter(projectGroup => {
        return projectGroup.name.toLowerCase().includes(searchString.toLowerCase());
      });
  
      this.handleSearchUsers(matchedProjects);
    }
    else{
      this.setState({ searchedProjectGroups: [] });
    }
  
    // Update the search string in state
    this.setState({ searchString });
  }

  render() {

    const { currentCompany } = this.props;

    const projectSearchFilter = (
      <ReportFilter minWidth={1000}>
      </ReportFilter>
    );
    
    let footerRow = null;
    // if(this.state.projects.length < this.state.totalProjects && !this.state.loadingMore){
    //   footerRow = <div className="scroll-footer">
    //     <div className="more-projects-row footer-card" onClick={this.handleLoadMoreProjects}>
    //       Load More
    //     </div>
    //   </div>;
    // }

    return (
      <section className='project-summary'>
        {this.state.isProjectGroupPopupActive && 
          <AddProjectGroupPopup
            currentCompany = {currentCompany}
            handleClosePopup = {this.handleCloseAddProjectGroupPopup}
            handleAddGroup = {this.handleAddGroup}
          />
        }
        <ReportHeader
          reportTitle={'Project Group Summary'}
          handleSearchInput={this.handleSearchChange}
          searchString={this.state.searchString}
          addProjectGroup={this.handleAddProjectGroup}
          hideFilterIcon={true}
          downloadKmz={true}
          currentCompany={currentCompany}
        />
        <div 
          className='project-summary-table'
          ref={el => this.projectTableContainer = el}
        >
          { projectSearchFilter }
          <article 
            className='project-rows-container'
            >
            {
              this.createProjectGroupRows()
            }
            {footerRow}
            {
              this.state.loadingMore &&
              <div className="loading-more-indicator"><LoadingDots /></div>
            }
          </article>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectSummary));



// WEBPACK FOOTER //
// ./src/containers/ProjectSummaryContainer/ProjectGroupsSummary/index.js